import { getAccessToken } from "../supabase";

const API_BASE = import.meta.env.VITE_API_URL || "http://localhost:8080";

export interface AgenticTaskSummary {
  id: string;
  title: string;
  status: string;
  mode: string;
  surface: string;
  provider?: string;
  updatedAt: string;
}

export interface AgenticArtifactSummary {
  id: string;
  title: string;
  artifactType: string;
  createdAt: string;
}

export interface AgenticProjection {
  conversationId: string;
  activeTask?: AgenticTaskSummary;
  tasks: AgenticTaskSummary[];
  pendingApprovals: AgenticTaskSummary[];
  draftArtifacts: AgenticArtifactSummary[];
  completedCount: number;
  failedCount: number;
  updatedAt: string;
}

export async function fetchAgenticProjection(input: {
  conversationId: string;
  partitionId?: string;
}): Promise<AgenticProjection> {
  const token = await getAccessToken();
  const params = new URLSearchParams();
  if (input.partitionId) params.set("partitionId", input.partitionId);
  const query = params.toString() ? `?${params}` : "";
  const response = await fetch(
    `${API_BASE}/api/ai/agentic/conversations/${input.conversationId}/projection${query}`,
    {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    },
  );
  const data = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(data?.error ?? "Agentic projection failed");
  }
  return data.projection as AgenticProjection;
}
